import { render, staticRenderFns } from "./industryCase.vue?vue&type=template&id=77c1b363&scoped=true&"
import script from "./industryCase.vue?vue&type=script&lang=js&"
export * from "./industryCase.vue?vue&type=script&lang=js&"
import style0 from "./industryCase.vue?vue&type=style&index=0&id=77c1b363&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c1b363",
  null
  
)

export default component.exports